export default {
    id: 'traffic-light',
    colors: ['#9C0125', '#FDCE34', '#228782'],
};
